import {EnfoldChildVisibility} from "./global/EnfoldChildVisibility";
import {fullHeight} from "./helpers/fullHeight";
import {fullWidth} from "./helpers/fullWidth";
import {handleCategoryDropdown} from "./helpers/handleCategoryDropdown";

/**
 * The main js Application
 */
export class App {

    /**
     * Runs the application
     */
    public run() {

        this.registerGlobals();
        console.log("application bootstrapped.");

        jQuery(document).ready(($ : JQueryStatic) => {
            if ($('body').hasClass('page-name-news')) {
                handleCategoryDropdown();
            }
        });
    }

    /**
     * Register global methods and objects here
     */
    protected registerGlobals() {
        EnfoldChildVisibility.initialize();
        EnfoldChildVisibility.add('fullHeight', fullHeight);
        EnfoldChildVisibility.add('fullWidth', fullWidth);
    }
}

